module.exports = "//docs.gtimg.com/slide/img/framework/editor/src/img/menu/menu_share44-6f0558.svg";